import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueRouter from 'vue-router'
import routes from './routes/route.config'
import './assets/style.css';
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueMeta from 'vue-meta'


Vue.use(VueRouter)
const router = new VueRouter({
  routes
})

Vue.use(VueMeta)

Vue.use(VueLoading);

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')